import { Link } from "react-router-dom";
import BrandName from "@/components/BrandName";

const COMPANY = "OrbitRank";

export default function RefundPolicy() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <header className="border-b border-border">
        <div className="container py-6 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 font-bold">
            <span className="w-7 h-7 rounded-md bg-primary/15 flex items-center justify-center">🚀</span>
            <BrandName />
          </Link>
          <Link to="/" className="text-sm text-muted-foreground hover:text-foreground">← Back to home</Link>
        </div>
      </header>

      <main className="container max-w-3xl py-16">
        <h1 className="text-4xl font-bold mb-2">Refund Policy</h1>
        <p className="text-sm text-muted-foreground mb-10">Last updated: April 17, 2026</p>

        <div className="space-y-6 text-[15px] leading-relaxed text-muted-foreground">
          <section>
            <div className="rounded-xl border border-primary/30 bg-primary/5 p-6 mb-8">
              <h2 className="text-2xl font-bold text-foreground mb-2">30-day money-back guarantee</h2>
              <p className="text-foreground/80">
                If you're not satisfied with OrbitRank, you can request a full refund within 30 days of
                your purchase — no questions asked.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">1. Refund window</h2>
            <p>
              {COMPANY} offers a 30-day money-back guarantee on all new OrbitRank subscription purchases.
              Refund requests submitted within 30 days of the original order date will be honoured in full.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">2. How to request a refund</h2>
            <p>
              Refunds are processed by our Merchant of Record, Paddle. To request a refund:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                Visit <a className="text-primary underline" href="https://paddle.net" target="_blank" rel="noreferrer">paddle.net</a> and look up your order using the email address you used at checkout.
              </li>
              <li>
                Or contact our support team via the chat widget on our website and we'll help you submit
                the request.
              </li>
            </ul>
            <p>Refunds are typically processed within 5–10 business days back to your original payment method.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">3. Cancellations vs. refunds</h2>
            <p>
              You can cancel your subscription at any time from your dashboard. Cancellation stops future
              renewals — you'll keep access to OrbitRank until the end of your current billing period.
              Cancellation alone does not trigger a refund of the current period; if you'd like a refund,
              please request one as described above.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">4. Free trial</h2>
            <p>
              We offer a 7-day free trial that requires no payment. If you don't subscribe before the trial
              ends, you simply lose access — there's nothing to refund.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">5. Renewals after the 30 days</h2>
            <p>
              After the initial 30-day guarantee window, subscription renewals are non-refundable except
              where required by applicable consumer protection law. We recommend cancelling before your next
              renewal date if you no longer wish to be billed.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">6. Chargebacks</h2>
            <p>
              Please contact us or Paddle before initiating a chargeback — we'll almost always be able to
              resolve the issue faster than your bank can.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">7. Questions</h2>
            <p>
              If anything is unclear, reach out via our chat widget and our team will help. See also our
              {" "}<Link to="/terms-of-service" className="text-primary underline">Terms of Service</Link> and
              {" "}<Link to="/privacy-policy" className="text-primary underline">Privacy Notice</Link>.
            </p>
          </section>
        </div>
      </main>

      <footer className="border-t border-border py-8 text-center text-xs text-muted-foreground">
        <div className="container flex flex-wrap justify-center gap-6">
          <Link to="/privacy-policy" className="hover:text-foreground">Privacy</Link>
          <Link to="/terms-of-service" className="hover:text-foreground">Terms</Link>
          <Link to="/refund-policy" className="hover:text-foreground">Refunds</Link>
        </div>
        <div className="mt-3">OrbitRank © 2026</div>
      </footer>
    </div>
  );
}
